/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable: no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IProductSpecificationViewProps } from './liquid-upc';

const ProductSpecificationView: React.FC<IProductSpecificationViewProps> = props => {
  const { ProductSpecification, ProductSpecificationTableProps, ProductSpecificationTableBodyProps, productSpecificationResult, buttontext, buttonlink } = props;

    
    return (
      <Module {...ProductSpecification}>
        <div className="retailers" id="retailers">

        
        {props.title}
          <Node {...ProductSpecificationTableProps}>
              <Node {...ProductSpecificationTableBodyProps}>
                <div className="inside-xl">
                    <div className="upc-contain flex-md">
                        {productSpecificationResult && productSpecificationResult.map((row) => {
                            return row;
                        })}
                        <div className="fifty">
                            <div className="flex-vertical text-center">
                                <div className="over-h3">{props.onlinetitle}</div>
                                <div className="upc-button">
                                    <a href={buttonlink}>{buttontext}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </Node>
          </Node>

        </div>
      </Module>
      
      );
};

export default ProductSpecificationView;

